import technicalFormations from './technicalFormations.json'

export const getTechnicalFormationBySlug = (slug) =>
  technicalFormations.find((formation) => formation.slug === slug)

export default technicalFormations
